(() => {
  'use strict';

  const MASTER_NUMBERS = new Set([11, 22, 33]);
  const VALID_RESULTS = new Set([1, 2, 3, 4, 5, 6, 7, 8, 9, 11, 22, 33]);

  function reduceMaster(value) {
    if (!Number.isInteger(value) || value < 1) throw new RangeError('Invalid numerology value');
    const steps = [value];
    while (value > 9 && !MASTER_NUMBERS.has(value)) {
      value = String(value).split('').reduce((sum, digit) => sum + Number(digit), 0);
      steps.push(value);
    }
    return { value, steps };
  }

  function parseDate(iso) {
    if (typeof iso !== 'string' || !/^[0-9]{4}-[0-9]{2}-[0-9]{2}$/.test(iso)) {
      throw new RangeError('Geçerli bir doğum tarihi seç.');
    }
    const [year, month, day] = iso.split('-').map(Number);
    const leap = year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
    const days = [31, leap ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    if (year < 1900 || month < 1 || month > 12 || day < 1 || day > days[month - 1]) {
      throw new RangeError('Geçerli bir doğum tarihi seç.');
    }
    return { year, month, day };
  }

  function localToday() {
    const now = new Date();
    return [now.getFullYear(), String(now.getMonth() + 1).padStart(2, '0'), String(now.getDate()).padStart(2, '0')].join('-');
  }

  function calculate(birthDate, today = localToday()) {
    const { year, month, day } = parseDate(birthDate);
    parseDate(today);
    if (birthDate > today) throw new RangeError('Geçerli bir doğum tarihi seç.');

    const monthReduction = reduceMaster(month);
    const dayReduction = reduceMaster(day);
    const yearSum = String(year).split('').reduce((sum, digit) => sum + Number(digit), 0);
    const yearReduction = reduceMaster(yearSum);
    const rawTotal = monthReduction.value + dayReduction.value + yearReduction.value;
    const finalReduction = reduceMaster(rawTotal);
    if (!VALID_RESULTS.has(finalReduction.value)) throw new Error('Invalid Life Path result');

    return {
      system: 'numerology',
      resultStatus: 'complete',
      lifePath: finalReduction.value,
      birthdayNumber: day,
      birthdayUndertone: dayReduction.value,
      calculationTrace: {
        birthMonthRaw: month,
        monthReductionSteps: monthReduction.steps,
        monthValue: monthReduction.value,
        birthDayRaw: day,
        dayReductionSteps: dayReduction.steps,
        dayValue: dayReduction.value,
        birthYearRaw: year,
        yearDigitSum: yearSum,
        yearReductionSteps: [yearSum, ...yearReduction.steps.slice(1)],
        yearValue: yearReduction.value,
        rawTotal,
        finalReductionSteps: finalReduction.steps
      }
    };
  }

  function sharePayload(result, themes = []) {
    if (!result || !VALID_RESULTS.has(result.lifePath)) throw new TypeError('Invalid result');
    return Object.freeze({
      brand: 'ASTERIA ELITE',
      system: 'numerology',
      lifePath: result.lifePath,
      themes: themes.filter((theme) => typeof theme === 'string').slice(0, 3)
    });
  }

  globalThis.AsteriaNumerology = Object.freeze({ calculate, sharePayload });
})();
